export enum AccountingImportDuplicateType {
    None = 0,
    Possible = 1,
    Sure = 2,
}

export class LibroFacturasRecibidas {
    emisor: string;
    CIF: string;
    pais: string;
    provincia: string;
    fechaFactura: Date;
    numeroFactura: string;
    base: number;
    impuesto1: string;
    impuesto2: string;
    total: number;
    cuentaContable: string;
    fechaPago: Date;
    forma: string;
    cajaCuenta: string;
    toImport: boolean;
    idContactImport: number;
    client: boolean;
    fila: number;
    duplicateType: AccountingImportDuplicateType;
    duplicateReason: string;
    importar: boolean;
    proyecto?: string;
    financiador?: string;
    partida?: string;
    subpartida?: string;
    familia?: string;
    avisos?: string[];


    constructor() { }
} 

export class LibroFacturasEmitidas {
    nombreCliente: string;
    pais: string;
    provincia: string;
    CIF: string;
    fechaFactura: Date;
    vencimiento: Date;
    cuentaContrable: string;
    tipoDeCobro: string;
    cuentaEfectivo: string;
    concepto: string;
    base: number;
    impuesto1: string;
    impuesto2: string;
    toImport: boolean;
    idContactImport: number;
    client: boolean;
    fila: number;
    duplicateType: AccountingImportDuplicateType;
    duplicateReason: string;
    importar: boolean;
    constructor() {}
}


export enum AccountingImportJobStatus {
    Queued = 0,
    Running = 1,
    Completed = 2,
    CompletedWithErrors = 3,
    Failed = 4,
}

export interface AccountingImportJobError {
    row: number;
    message: string;
}

export interface AccountingImportJob {
    uid: string;
    type: number;
    status: AccountingImportJobStatus;
    total: number;
    processed: number;
    imported: number;
    failed: number;
    percentage: number;
    finished: boolean;
    errorMessage: string;
    errors: AccountingImportJobError[];
    createdAt: string;
    finishedAt: string;
}
